import { login } from '@/services/oidc.service';

const canActivate = (to) => {
    if (localStorage.getItem('token') != undefined) {
        if (to?.meta?.skipOrgCheck) {
            return true;
        }
        else {
            // Checks if client selected it`s respective org
            if (localStorage.getItem('org') != undefined) {
                return true;
            }
            else {
                // Redirects to org selector
                if (window.location.href != window.location.origin + "/init") {
                    window.location.href = "init";
                }
                
                return true;
            }
        }
    }

    // Navigate to login page
    localStorage.clear();
    login();
    return false;
};

export {
    canActivate
}